<!-- <div [ngClass]="{'sidebar-active': app.sidebarActive}" class="flex">
    <div class="sidebar-next-right-block"
         style="width: 100%;"
         [ngClass]="{'map-padding': activeMenu === menuEnum.MapsRegionMapEditor}">
        
        <home-settings *ngIf="activeMenu === menuEnum.SystemFlags"
                       [menuPermissionActive]="menuPermissionActive"></home-settings>
        <user-managment-all-users *ngIf="activeMenu === menuEnum.UserManagmentAllUsers"
                                  [menuPermissionActive]="menuPermissionActive"></user-managment-all-users>
        <user-managment-roles *ngIf="activeMenu === menuEnum.UserManagmentRoles"
                              [menuPermissionActive]="menuPermissionActive"></user-managment-roles>
        <region-map-editor *ngIf="activeMenu === menuEnum.MapsRegionMapEditor"
                           class="live-map-content"
                           [menuPermissionActive]="menuPermissionActive"></region-map-editor>
    </div>
</div> -->

<div data-testid="settings-root">
<home-settings
>
</home-settings>
</div>
